'use es6';

import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const SVGTextBase = props => /*#__PURE__*/_jsx("text", Object.assign({
  x: "50",
  width: "100%"
}, props));
export default styled(SVGTextBase).withConfig({
  displayName: "SVGTextStyle",
  componentId: "sc-1rp2rll-0"
})(["alignment-baseline:middle;dominant-baseline:middle;text-transform:uppercase;user-select:none;"]);